import React, {useState, useEffect, useCallback, useRef, useContext} from 'react';
import {useSDK} from "@metamask/sdk-react";
import Header from '../components/Header';
import HeaderHidden from '../components/HeaderHidden';
import Section05 from '../components/Section05';
import '../css/pages/Merge.css';
import {ApiContext} from "../App";
import {unstable_HistoryRouter, useNavigate} from "react-router-dom";
import BeatLoader from "react-spinners/BeatLoader";
import Modal from "react-modal";
import {useWallet} from "@aptos-labs/wallet-adapter-react";

interface imgList {
    tokenId: number;
    name: string;
    description: string;
    image: string;
    isPurgeMerged: boolean;
    attributes: [];
    animation_url: string;
}

interface BellyLandItem {
    tokenId: number;
    name: string;
    description: string;
    image: string;
    isPurgeMerged: boolean;
    attributes: any[]; // 속성 타입이 명확하지 않아서 any[]로 설정
    animation_url: string;
}

interface ModalBeatLoaderProps {
    isOpen: boolean;
    onClose: () => void;
    address: string | null | undefined;
}

interface isPopupProps {
    isOpen: boolean;
    onClose: () => void;
    isMerged: boolean;
    gifUrl : String;
    name : String;
}

const Merge: React.FC = () => {
    const apiUrl = useContext(ApiContext);
    const navigate = useNavigate();
    // const [checkedItems, setCheckedItems] = useState<number[]>([]);
    const [search, setSearch] = useState('');
    const [checkID, setCheckID] = useState(0);
    const [codeNum, setCodeNum] = useState('');


    const [imgList, setImgList] = useState<imgList[]>([{
        tokenId: 2,
        name: 'BellyLand #222',
        description: "# BellyLand\n\n“BellyLand” represents the second collection featuring Bellygom, an immensely popular IP character in Korea that was created by Lotte Group, one of South Korea’s leading conglomerates.\nBellyLand showcases Bellygom’s next journey into an exciting adventure. Through the world of Bellygom and BellyLand, you will unlock the vision of Lotte Group’s web3 and gain access to the future with Lotte Group.",
        image: "https://cdn.bellygom.scv.sh/bellyland/assets/Nobelly_Belly-sailles-Day.png",
        isPurgeMerged: true,
        attributes: [],
        animation_url: "https://cdn.bellygom.scv.sh/bellyland/belly-saille-no-belly.html"
    },
        {
            tokenId: 3,
            name: "BellyLand #3",
            description: "# BellyLand\n\n“BellyLand” represents the second collection featuring Bellygom, an immensely popular IP character in Korea that was created by Lotte Group, one of South Korea’s leading conglomerates.\nBellyLand showcases Bellygom’s next journey into an exciting adventure. Through the world of Bellygom and BellyLand, you will unlock the vision of Lotte Group’s web3 and gain access to the future with Lotte Group.",
            image: "https://cdn.bellygom.scv.sh/bellyland/assets/Nobelly_ForgottenTemple-Day.png",
            isPurgeMerged: true,
            attributes: [],
            animation_url: "https://cdn.bellygom.scv.sh/bellyland/forgotten-temple-no-belly.html"
        },
        {
            tokenId: 5,
            name: "BellyLand #3",
            description: "# BellyLand\n\n“BellyLand” represents the second collection featuring Bellygom, an immensely popular IP character in Korea that was created by Lotte Group, one of South Korea’s leading conglomerates.\nBellyLand showcases Bellygom’s next journey into an exciting adventure. Through the world of Bellygom and BellyLand, you will unlock the vision of Lotte Group’s web3 and gain access to the future with Lotte Group.",
            image: "https://cdn.bellygom.scv.sh/bellyland/assets/Nobelly_ForgottenTemple-Day.png",
            isPurgeMerged: true,
            attributes: [],
            animation_url: "https://cdn.bellygom.scv.sh/bellyland/forgotten-temple-no-belly.html"
        },
        {
            tokenId: 6,
            name: "BellyLand #3",
            description: "# BellyLand\n\n“BellyLand” represents the second collection featuring Bellygom, an immensely popular IP character in Korea that was created by Lotte Group, one of South Korea’s leading conglomerates.\nBellyLand showcases Bellygom’s next journey into an exciting adventure. Through the world of Bellygom and BellyLand, you will unlock the vision of Lotte Group’s web3 and gain access to the future with Lotte Group.",
            image: "https://cdn.bellygom.scv.sh/bellyland/assets/Nobelly_ForgottenTemple-Day.png",
            isPurgeMerged: true,
            attributes: [],
            animation_url: "https://cdn.bellygom.scv.sh/bellyland/forgotten-temple-no-belly.html"
        },
        {
            tokenId: 7,
            name: "BellyLand #3",
            description: "# BellyLand\n\n“BellyLand” represents the second collection featuring Bellygom, an immensely popular IP character in Korea that was created by Lotte Group, one of South Korea’s leading conglomerates.\nBellyLand showcases Bellygom’s next journey into an exciting adventure. Through the world of Bellygom and BellyLand, you will unlock the vision of Lotte Group’s web3 and gain access to the future with Lotte Group.",
            image: "https://cdn.bellygom.scv.sh/bellyland/assets/Nobelly_ForgottenTemple-Day.png",
            isPurgeMerged: true,
            attributes: [],
            animation_url: "https://cdn.bellygom.scv.sh/bellyland/forgotten-temple-no-belly.html"
        },
        {
            tokenId: 8,
            name: "BellyLand #3",
            description: "# BellyLand\n\n“BellyLand” represents the second collection featuring Bellygom, an immensely popular IP character in Korea that was created by Lotte Group, one of South Korea’s leading conglomerates.\nBellyLand showcases Bellygom’s next journey into an exciting adventure. Through the world of Bellygom and BellyLand, you will unlock the vision of Lotte Group’s web3 and gain access to the future with Lotte Group.",
            image: "https://cdn.bellygom.scv.sh/bellyland/assets/Nobelly_ForgottenTemple-Day.png",
            isPurgeMerged: true,
            attributes: [],
            animation_url: "https://cdn.bellygom.scv.sh/bellyland/forgotten-temple-no-belly.html"
        },
        {
            tokenId: 9,
            name: "BellyLand #3",
            description: "# BellyLand\n\n“BellyLand” represents the second collection featuring Bellygom, an immensely popular IP character in Korea that was created by Lotte Group, one of South Korea’s leading conglomerates.\nBellyLand showcases Bellygom’s next journey into an exciting adventure. Through the world of Bellygom and BellyLand, you will unlock the vision of Lotte Group’s web3 and gain access to the future with Lotte Group.",
            image: "https://cdn.bellygom.scv.sh/bellyland/assets/Nobelly_ForgottenTemple-Day.png",
            isPurgeMerged: true,
            attributes: [],
            animation_url: "https://cdn.bellygom.scv.sh/bellyland/forgotten-temple-no-belly.html"
        },
        {
            tokenId: 9,
            name: "BellyLand #3",
            description: "# BellyLand\n\n“BellyLand” represents the second collection featuring Bellygom, an immensely popular IP character in Korea that was created by Lotte Group, one of South Korea’s leading conglomerates.\nBellyLand showcases Bellygom’s next journey into an exciting adventure. Through the world of Bellygom and BellyLand, you will unlock the vision of Lotte Group’s web3 and gain access to the future with Lotte Group.",
            image: "https://cdn.bellygom.scv.sh/bellyland/assets/Nobelly_ForgottenTemple-Day.png",
            isPurgeMerged: true,
            attributes: [],
            animation_url: "https://cdn.bellygom.scv.sh/bellyland/forgotten-temple-no-belly.html"
        },
        {
            tokenId: 10,
            name: "BellyLand #3",
            description: "# BellyLand\n\n“BellyLand” represents the second collection featuring Bellygom, an immensely popular IP character in Korea that was created by Lotte Group, one of South Korea’s leading conglomerates.\nBellyLand showcases Bellygom’s next journey into an exciting adventure. Through the world of Bellygom and BellyLand, you will unlock the vision of Lotte Group’s web3 and gain access to the future with Lotte Group.",
            image: "https://cdn.bellygom.scv.sh/bellyland/assets/Nobelly_ForgottenTemple-Day.png",
            isPurgeMerged: true,
            attributes: [],
            animation_url: "https://cdn.bellygom.scv.sh/bellyland/forgotten-temple-no-belly.html"
        },
        {
            tokenId: 11,
            name: "BellyLand #3",
            description: "# BellyLand\n\n“BellyLand” represents the second collection featuring Bellygom, an immensely popular IP character in Korea that was created by Lotte Group, one of South Korea’s leading conglomerates.\nBellyLand showcases Bellygom’s next journey into an exciting adventure. Through the world of Bellygom and BellyLand, you will unlock the vision of Lotte Group’s web3 and gain access to the future with Lotte Group.",
            image: "https://cdn.bellygom.scv.sh/bellyland/assets/Nobelly_ForgottenTemple-Day.png",
            isPurgeMerged: false,
            attributes: [],
            animation_url: "https://cdn.bellygom.scv.sh/bellyland/forgotten-temple-no-belly.html"
        },
        {
            tokenId: 12,
            name: "BellyLand #3",
            description: "# BellyLand\n\n“BellyLand” represents the second collection featuring Bellygom, an immensely popular IP character in Korea that was created by Lotte Group, one of South Korea’s leading conglomerates.\nBellyLand showcases Bellygom’s next journey into an exciting adventure. Through the world of Bellygom and BellyLand, you will unlock the vision of Lotte Group’s web3 and gain access to the future with Lotte Group.",
            image: "https://cdn.bellygom.scv.sh/bellyland/assets/Nobelly_ForgottenTemple-Day.png",
            isPurgeMerged: false,
            attributes: [],
            animation_url: "https://cdn.bellygom.scv.sh/bellyland/forgotten-temple-no-belly.html"
        },
        {
            tokenId: 4,
            name: "BellyLand #4",
            description: "# BellyLand\n\n“BellyLand” represents the second collection featuring Bellygom, an immensely popular IP character in Korea that was created by Lotte Group, one of South Korea’s leading conglomerates.\nBellyLand showcases Bellygom’s next journey into an exciting adventure. Through the world of Bellygom and BellyLand, you will unlock the vision of Lotte Group’s web3 and gain access to the future with Lotte Group.",
            image: "https://cdn.bellygom.scv.sh/bellyland/assets/Nobelly_ForgottenTemple-Day.png",
            isPurgeMerged: true,
            attributes: [],
            animation_url: "https://cdn.bellygom.scv.sh/bellyland/forgotten-temple-no-belly.html"
        }]);
    const [imgListResults, setImgListResults] = useState<imgList[]>([]);
    const [searchResults, setSearchResults] = useState<BellyLandItem[]>(); // 검색 결과 상태
    const containerRef = useRef<HTMLDivElement>(null); // container 요소 참조 생성
    const [isScrollingDown, setIsScrollingDown] = useState(false);
    const [lastScrollY, setLastScrollY] = useState(0); // 마지막 스크롤 위치
    // const [isVisible, setIsVisible] = useState(false);
    const {sdk, connected, connecting, provider, chainId} = useSDK();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isModalOpen2, setIsModalOpen2] = useState(false);
    const [isMerged, setIsMerged] = useState(false);
    const [gifUrl, setGifUrl] = useState('');
    const [imgName, setImgName] = useState('');

    ///image/merge_cristal.gif

    const MetaMaskKey = localStorage.getItem('MetaMask');
    // const MetaMaskKey = '0x454383190c3fC7c1887f34F8D25A6d8a20D8FcE7';

    const [account, setAccount] = useState(null);

    useEffect(() => {
        const checkWalletConnection = async () => {
            try {
                const storedWallet = localStorage.getItem("MetaMask");
                // 1. localStorage에 MetaMask 지갑 정보 없으면 메인으로 이동
                if (!storedWallet) {
                    console.warn("지갑 정보 없음. 메인 페이지로 이동");
                    navigate("/");
                    return;
                }
            } catch (error) {
                console.error("지갑 연결 확인 오류:", error);
                navigate("/");
            }
        };

        checkWalletConnection();
    }, [sdk, navigate]);


    //0x64220B85356c2E31AA5B2DD79322dbAB63d05f22
    // 1. 0xAFd8e008275aE08a949656B4faA793158Df81ada
    // 2. 0x8dd6CCb3300fa4C3497aA6D18F2CcaA2D311d360
    // 3. 0xD50C8e9Ff4D9482ee0edDAde5bF02ac268b4Af80
    // 4. 0x454383190c3fC7c1887f34F8D25A6d8a20D8FcE7
    // 5. 0xC47Dbc6ed5C03d7d7E9e62223aa086Ad31D4CE3b

    // const handleCheckboxChange = (index: number) => {
    //   setCheckedItems(prev =>
    //     prev.includes(index) ? prev.filter(item => item !== index) : [...prev, index]
    //   );
    // };

    const handleCheckboxChange = (token: number) => {
        if (checkID === token) {
            setCheckID(0);
        } else {
            setCheckID(token);
        }

    };

    function isMobile() {
        var userAgent = navigator.userAgent || navigator.vendor;
        // 모바일 장치 식별을 위한 정규식
        if (/android/i.test(userAgent) || /iphone|ipod|ipad/i.test(userAgent)) {
            return true;  // 모바일 장치
        }
        return false;  // PC
    }

    useEffect(() => {
        window.scrollTo(0, 0);

        const root = document.getElementById("root");
        if (root) {
            if (isMobile()) {
                root.style.height = "100%"; // 100% 대신 100vh 사용
            }
        }

    }, []);

    const fetchData = async () => {
        try {
            if (!MetaMaskKey) {
                return false;
            }

            const requestOptions = {
                method: "GET",
                redirect: "follow"
            };
            setIsModalOpen2(true);
            //merge-api.bellygom.world
            //merge-api.bellygom.scv.sh
            // @ts-ignore
            fetch(`https://merge-api.bellygom.world/api/usernfts?address=${MetaMaskKey}`, requestOptions)
                .then((response) => response.text())
                .then((result) => {
                    if (!result) {
                        throw new Error("Empty response from server");
                    }

                    console.log("result :", result);
                    const jsonResult: BellyLandItem[] = JSON.parse(result); // JSON으로 변환
                    setSearchResults(jsonResult);
                    // @ts-ignore
                    setImgListResults(jsonResult);
                })
                .finally(() => setIsModalOpen2(false))
                .catch((error) => console.error(error));
        } catch (error) {
            console.error('Failed to fetch event data:', error);
        }
    };

    //MetaMaskKey가 있을경우 지갑 정보 조회
    useEffect(() => {
        fetchData();
    }, [MetaMaskKey]);


    // 이름에 검색어가 포함되어 있는지 확인하는 함수
    const searchByName = (searchTerm: string) => {
        if (searchTerm.trim() === '') {
            // 검색어가 없으면 전체 리스트를 반환
            setSearchResults(imgListResults);
        } else {
            // 검색어가 있으면 해당 단어가 포함된 항목만 필터링
            const filteredList = imgListResults.filter(item =>
                item.name.toLowerCase().includes(searchTerm.toLowerCase())
            );
            setSearchResults(filteredList);
        }
    };

    const updateMerge = () => {

        if (checkID === 0) {
            alert('Please select an image.');
            return false;
        } else if(codeNum === ''){
            alert('Please enter coupon number.');
            return false;
        } else {
            const requestOptions = {
                method: "POST",
                redirect: "follow"
            };

            // @ts-ignore
            fetch(`${apiUrl}/api/land/merge/update/${checkID}?codeNum=${codeNum}`, requestOptions)
                .then((response) =>{
                        // 응답 형식 확인 후 처리
                        const contentType = response.headers.get("Content-Type");
                        if (contentType && contentType.includes("application/json")) { // JSON 응답일 경우
                            return response.json(); // JSON으로 파싱하여 처리
                        } else { // 텍스트 응답일 경우
                            return response.text(); // 텍스트로 처리
                        }
                    }
                )
                .then((result) =>{
                    // result가 JSON 형식일 때 처리
                    if (typeof result === 'object' && result !== null) {
                        if (result.success === false && result.code === 'ERR003') {
                            console.log("Not Authorized:", result.reason);
                        } else {
                            console.log("Other JSON Response:", result);
                            // fetchData();
                        }
                    }
                    // result가 텍스트일 때 처리
                    else if (typeof result === 'string') {

                        if (result.trim() === "already used") { //이미 머지가 된경우
                            alert("This coupon number has already been used.");

                        } else if(result.trim() === "no data"){ //merge api 에 데이터가 없는경우
                            alert("This is incorrect code.");
                        } else { //성공

                            const res = JSON.parse(result);

                            if(res.success === true){
                                //모달 오픈
                                setIsModalOpen(true);
                                //gif 이미지 경로 셋팅
                                setGifUrl(res.image); //gif 이미지 url
                                //현재 선택한 카드의 이름 검색 및 셋팅
                                const foundItem = imgListResults.find(item => item.tokenId === checkID);
                                if (foundItem) {
                                    // @ts-ignore
                                    setImgName(foundItem.name);
                                } else {
                                    console.error("Item not found for checkID:", checkID);
                                }
                                // 2초 후 머지 완료 상태로 변경
                                setTimeout(() => {
                                    setIsMerged(true);
                                }, 2000);

                            }else{ //코드가 사용된 경우
                                alert("This coupon number has already been used.");
                            }
                        }
                    }
                })
                .catch((error) => console.error(error));
        }
    };

    // onKeyDown 이벤트 핸들러
    const activeEnter = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === 'Enter') {
            searchByName(search);
        }
    };

    const activeEnter2 = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === 'Enter') {
            updateMerge()
        }
    };

    //모달 닫기시 리로드
    const closeModal = () => {
        window.location.reload();
    };

    const handleScroll = (event: React.WheelEvent) => {
        if (containerRef.current) {
            containerRef.current.scrollTop += event.deltaY;
        }

        // @ts-ignore
        if(event.deltaY == "-100" || event.deltaY == "-50"){
            setIsScrollingDown(false);
        }else { // @ts-ignore
            if(event.deltaY == "100" || event.deltaY == "50"){
                setIsScrollingDown(true);
            }
        }
    };

    const mobileScroll = useCallback(() => {
        const currentScrollY = window.scrollY;

        if (currentScrollY > lastScrollY && currentScrollY > 50) {
            setIsScrollingDown(true);
        } else {
            setIsScrollingDown(false);
        }

        setLastScrollY(currentScrollY); // 스크롤 위치 갱신
    }, [lastScrollY]);

    useEffect(() => {
        window.addEventListener("scroll", mobileScroll);
        return () => {
            window.removeEventListener("scroll", mobileScroll);
        };
    }, [mobileScroll]);

    // 마우스 휠 스크롤 이벤트 추가
    useEffect(() => {
        const handleWheel = (event: WheelEvent) => {
            const containerElement = containerRef.current;
            if (containerElement) {
                // scrollTop 값을 deltaY만큼 증가시킵니다.
                containerElement.scrollTop += event.deltaY;
            }
        };

        // containerRef가 null이 아닌 경우에만 이벤트 리스너를 추가
        const containerElement = containerRef.current;
        containerElement?.addEventListener('wheel', handleWheel);

        // 컴포넌트 언마운트 시 이벤트 리스너 제거
        return () => {
            containerElement?.removeEventListener('wheel', handleWheel);
        };
    }, []);

    const disconnect = async () => {
        const message = 'Would you like to cancel the wallet connection?';

        if (window.confirm(message)) {
            if (sdk) {
                try {
                    await sdk.disconnect(); // 비동기 처리 고려
                    localStorage.removeItem('MetaMask');
                    navigate('/'); // 메인 페이지 이동
                } catch (error) {
                    console.error('Failed to disconnect:', error);
                    alert('Failed to disconnect. Please try again.');
                }
            } else {
                console.warn('SDK is not initialized.');
            }
        }
    };

    // @ts-ignore
    return (
        <>
            <div className="project_bg" onWheel={handleScroll} ref={containerRef}>
                <HeaderHidden isHidden={isScrollingDown} />
                <section id="project" className={"merge-bg"}>
                    <div className="merge-section">
                        <div className="container merge-container">
                            <div className={"merge_headerBox"}>
                                <h2 className={"merge_h2"}>If you check the item, the MERGE button will be activated!</h2>
                                <div className={'disconnect_container'}>
                                    <div className="search_box">
                                        <input
                                            placeholder="Search"
                                            onChange={(e) => {
                                                setSearch(e.target.value)
                                            }}
                                            onKeyDown={activeEnter}
                                        />
                                        <button
                                            onClick={() => {
                                                searchByName(search);
                                            }}
                                        >
                                            <img src="/image/zoom.png" alt="Search"/>
                                        </button>
                                    </div>
                                    <button className={"disconnect_btn"} onClick={() => disconnect()} style={{border: '0px'}}>
                                        <img src="/image/disconnect.png" alt="disconnect" style={{width: '100%'}}/>
                                    </button>
                                </div>
                            </div>

                            <div className="merge-panel dflex-ac-jc merge-box">
                                {searchResults && searchResults.map((_el, index) => (
                                    <a href="javascript: void(0)"
                                       onClick={() => _el.isPurgeMerged === false ? handleCheckboxChange(_el.tokenId) : ``}
                                       key={index}
                                       className={`merge-btn ${_el.isPurgeMerged === false ? "" : "already"} ${checkID === _el.tokenId ? "neon-border" : ""}`}>
                                        <div className={`g-panel w-ba`}>
                                            {_el.isPurgeMerged === false ?
                                                <input
                                                    type="checkbox"
                                                    checked={checkID === _el.tokenId ? true : false}
                                                    onChange={() => handleCheckboxChange(_el.tokenId)}
                                                />
                                                :
                                                ``
                                            }

                                            <div className={"merge-image"}>
                                                <img className="g-img"
                                                     // loading="lazy"
                                                     src={`${_el.image}`}
                                                     alt={`Pudgy Penguin ${index + 1}`}/>
                                            </div>
                                            <div className={"merge-text"}>
                                                <p>{_el.name}</p>
                                                <span>#{_el.tokenId}</span>
                                            </div>

                                        </div>
                                    </a>
                                ))}
                            </div>
                            <div className="merge_code">
                                <div className={"merge-number"}>
                                    <span className={"merge-numb"}>NUMBER</span>
                                    <input
                                        type="text"
                                        onChange={(e) => {
                                            setCodeNum(e.target.value);
                                        }}
                                        onKeyDown={activeEnter2}
                                    />
                                </div>
                                <button
                                    className={`merge_btn ${checkID === 0 ? 'disabled' : 'active'} ${codeNum.length >= 8 ? `` : 'transparent-button'}`}
                                    // disabled={codeNum.length === 8 ? true : false}
                                    onClick={() => {
                                        if (checkID === 0) {
                                            alert("Please select an image."); // 경고창 표시
                                            return;
                                        }
                                        updateMerge();
                                    }}
                                >
                                    MERGE
                                </button>
                            </div>
                        </div>
                    </div>
                </section>
                <Section05/>
            </div>
            {isModalOpen === true ? <Popup isOpen={isModalOpen} onClose={closeModal} isMerged={isMerged} gifUrl={gifUrl} name={imgName}/> : ``}
            {isModalOpen2 === true ? <Popup2 /> : ``}
        </>
    );
};

const Popup: React.FC<isPopupProps> = ({isOpen, onClose, isMerged, gifUrl,name}) => {


    return (
        <div>
            <div
                className="modal-overlay_new"
                style={{
                    position: 'fixed',
                    top: '0',
                    left: '0',
                    width: '100%',
                    height: '100%',
                    backgroundColor: 'rgba(0, 0, 0, 0.7)',
                    zIndex: '10000'
                }}
            ></div>

            <div className="merge_modal" tabIndex={-1} role="dialog" aria-modal="true"
                 style={{zIndex: '10000'}}
            >
                {isMerged === true ?
                    <>
                        <h2>They’ve Arrived Safely At {name}</h2>
                        <img src={`${gifUrl}`} alt={""}/>
                        <button onClick={onClose}><img src="/image/merge_confirm_btn.png" alt={''}/></button>
                    </> :
                    <>
                        <h2 style={{paddingBottom: '55px'}}>Pengu and Polly are flying to Bellyland now!</h2>
                        <BeatLoader color={'black'}/>
                    </>
                }
            </div>
        </div>
    )
}

const Popup2: React.FC = () => {


    return (
        <div>
            <div
                className="modal-overlay_new"
                style={{
                    position: 'fixed',
                    top: '0',
                    left: '0',
                    width: '100%',
                    height: '100%',
                    backgroundColor: 'rgba(0, 0, 0, 0.7)',
                    zIndex: '10000'
                }}
            ></div>

            <div className="merge_modal" tabIndex={-1} role="dialog" aria-modal="true"
                 style={{zIndex: '10000'}}
            >
                <>
                    <h2 style={{paddingBottom: '55px'}}>Loading your Bellyland</h2>
                    <BeatLoader color={'black'}/>
                </>
            </div>
        </div>
    )
}

export default Merge;

// 빈 export 구문 추가
export {};